import * as types from './typeNames'

export const generalChangeValue = (propSector, propName, value) => ({
    type: types.CHANGE_ANY_VALUE,
    propSector,
    propName,
    value
})

export const changeFontValues = (propSector, propName, value) => ({
    type: types.CHANGE_FONT_VALUES,
    propSector,
    propName,
    value
})